import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-no-items',
    templateUrl: './no-items.component.html',
    styleUrls: ['./no-items.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [TranslateModule]
})
export class NoItemsComponent implements OnInit {

  @Input() addNewClass;

  constructor() { }
  ngOnInit() {
  }

}
